module.exports = __webpack_public_path__ + "img/madera009.c02cd8e6.jpg";